import React, { useEffect, useState } from 'react'
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import api from '../../../api/api';
import apifunctions from '../../../api/functions';


const FinalizarOTT = ({ onSubmit, id, row }) => {
  const [show, setShow] = useState(false);
  const [imputacion, setImputacion] = useState(false);
  const [error, setError] = useState(null);

  const imp_id = id && id();

  useEffect(() => {
    if (imp_id && show) {
      const getAndProcess = (reintento = 0) => {
        const failureCallback = () => {

        }
        const successCallback = (data) => {
          if(data.success){
            setImputacion({
              ...data.imputacion,
              codigo: data.imputacion.cod,
              nroFactura: data.imputacion.nroFactura,
              ottNombre: data.ott_nombre,
              ottEmail: data.ott_email,
            })
          }else{
            setError(data.error);
          }
        }
        apifunctions.get(api.imputaciones.imputaciones.finalizar, imp_id, null, null, successCallback, failureCallback, failureCallback);
      }
      getAndProcess();
    }
  }, [show]);

  const finalizada = imputacion && imputacion.separaciones.every(sep => sep.finalizada);

  const toggle = () => setShow(!show);

  const enviar = () => {
    const callback = () => {setImputacion(false); onSubmit()};
    apifunctions.post(api.imputaciones.imputaciones.finalizar, imp_id, null, callback, callback, callback);
    setShow(false);
  }

  const permisos = (localStorage.permisos.includes('administrador') || (row() && row().imputar));

  return (
    
    <React.Fragment>
       {permisos &&
        <React.Fragment>
      <Button
        id="btn-enviar-ott"
        color={"success"}
        className="btn-sm h-100 rounded"
        onClick={() => setShow(true)}
      ><i className="fa fa-check-circle-o"></i></Button>
      <UncontrolledTooltip target="btn-enviar-ott">
        Finalizar
      </UncontrolledTooltip>
      <Modal className="ui-modal-dialog ui-modal-md modal-primary" toggle={toggle} isOpen={show}>
        <ModalHeader toggle={toggle}>
          Finalizar Imputación
        </ModalHeader>
        <ModalBody>
          <div className="ui-form">
            {(error && error.Lider) && <Alert color="danger">{error.Lider}</Alert>}
            {
              imputacion && imp_id &&
              <section className="ui-section-block">
                <h5 className="ui-section-label">Datos de la imputación</h5>
                <div className="ui-detail-list">
                  <div><span>Presupuesto</span><strong>{imputacion.codigo}</strong></div>
                  <div><span>Nro Factura</span><strong>{imputacion.nroFactura}</strong></div>
                  <div><span>OTT</span><strong>{`${imputacion.ottNombre} (${imputacion.ottEmail})`}</strong></div>
                </div>
              </section>
            }
            <section className="ui-section-block">
              <h5 className="ui-section-label">Estado</h5>
              {
                finalizada ? (
                  <p className="mb-0">Se dará por finalizada la imputación.</p>
                ) : (
                  <Alert color="danger" className="mb-0">
                    {
                      imp_id
                      ? "Imputación no finalizada. Hay distribuciones sin finalizar."
                      : "No hay Imputación seleccionada."
                    }</Alert>
                )
              }
            </section>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={!finalizada}
            color="success"
            className="rounded btn-md"
            onClick={enviar}
          >Confirmar</Button>
          {' '}
          <Button
            onClick={() => setShow(false)}
            color="secondary"
            className="rounded btn-md"
            >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal> 
      </React.Fragment>
      }
    </React.Fragment>
    )
}

export default FinalizarOTT;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/FinalizarOTT.js